// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__4xHH_","label":"styles_label__ntAqg","caption":"styles_caption__0moLu","description":"styles_description__WDwfy","content":"styles_content__brZhR"};